import React from 'react';
import styled from 'styled-components';
import uniqid from 'uniqid';
import PropTypes from 'prop-types';
import { rem } from 'polished';
import { Label, Select } from 'oxyrion-ui/lib';
import { connect } from '../../Store';
import MultiSelect from '../MultiSelect';
import { __ } from '../../Utils';

const InputWrapperInline = styled.div`
  display: inline-block;
  padding: ${rem(10)};
  vertical-align: bottom;
`;

const CustomMultiSelect = styled(MultiSelect)`
  width: 100%;
  margin: ${rem(10)} 0;
  padding: 0;
  background-color: ${({ error, theme }) => error && theme.color.danger};

  input {
    box-sizing: border-box;
  }
`;

const Row = styled.div`
  display: flex;
`;

const Text = styled.div`
  display: flex;
  align-items: center;
  font-size: ${rem(16)};
  margin: 0 ${rem(5)};
  width: ${rem(130)};
`;

class SelectForm extends React.Component {
  constructor(props) {
    super(props);
    this.typeOfService = {
      selOptions: ['Služba'],
      Služba: {
        selOptions: [
          'Vyberte',
          'Marketing',
          'Servis stroja',
          'Reklamácia',
          // 'Iné',
        ],
        Marketing: {
          selOptions: ['Požiadavka'],
          Požiadavka: {
            selOptions: ['Vyberte', 'Inštalácia', 'Marketingový meteriál'],
            Inštalácia: {
              selOptions: ['Špecifikácia'],
              Špecifikácia: {
                selOptions: [
                  'Vyberte',
                  'výkladov',
                  'banerov',
                  'regálov',
                  'svetelných zariadení,vzorkovíkov',
                ],
              },
            },
            'Marketingový meteriál': {
              selOptions: ['Špecifikácia'],
              Špecifikácia: {
                selOptions: [
                  'Vyberte',
                  'katalógy',
                  'vzorkovníky',
                  'marketingový materiál ostatný',
                  'karta bezpečnostných údajov a technický list',
                  'ostatné marketingové informácie',
                ],
              },
            },
          },
        },
        'Servis stroja': {
          selOptions: ['Prípad', 'Typ stroja'],
          Prípad: {
            selOptions: ['Vyberte', 'Servisná prehliadka', 'Servis'],
          },
          'Typ stroja': {
            selOptions: [],
          },
        },
        Reklamácia: {
          selOptions: ['Oblasť reklamácie'],
          'Oblasť reklamácie': {
            selOptions: [
              'Vyberte',
              'Preprava',
              'Produkt',
              'Aplikácia',
              'Tónovanie',
            ],
            Preprava: {
              selOptions: ['Druh reklamácie'],
              'Druh reklamácie': {
                selOptions: [
                  'Vyberte',
                  'Poškodený tovar',
                  'Nedodaný tovar',
                  'Chýbajúce dokumenty',
                  'Iné',
                ],
              },
            },
            Produkt: {
              selOptions: ['Druh reklamácie'],
              'Druh reklamácie': {
                selOptions: [
                  'Vyberte',
                  'Vo farbe je kôra',
                  'Produkt je poškodený',
                  'Produkt sa javí vadný',
                  'Produkt je po záruke',
                  'Iné',
                ],
              },
            },
            Aplikácia: {
              selOptions: ['Druh reklamácie'],
              'Druh reklamácie': {
                selOptions: [
                  'Vyberte',
                  'Problém s aplikáciou',
                  'Vzhľad povrchu je nevyhovujúci',
                  'Odtieň je nerovnomerný',
                  'Povrch vykazuje chyby',
                  'Farba sa olupuje',
                  'Povrch hrdzavie',
                  'Iné',
                ],
              },
            },
            Tónovanie: {
              selOptions: ['Druh reklamácie'],
              'Druh reklamácie': {
                selOptions: [
                  'Vyberte',
                  'Nesprávny odtieň',
                  'Odtieň je nerovnomerný',
                  'Iné',
                ],
              },
            },
          },
        },
        /* Iné: {
          selOptions: ['Požiadavka', 'Špecifikácia'],
          Požiadavka: { selOptions: ['Vyberte', 'value'] },
          Špecifikácia: { selOptions: ['Vyberte', 'value'] },
        }, */
      },
    };

    this.state = {
      formMode: 'add',
      machineOptions: [],
    };
  }

  componentDidMount() {
    const { editMode, machines } = this.props;
    if (editMode) {
      this.setState({
        formMode: editMode,
      });
    }
    if (machines) {
      this.typeOfService['Služba']['Servis stroja'][
        'Typ stroja'
      ].selOptions = this.getMachinesTypes();
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const { editMode, machines } = this.props;
    if (editMode !== prevProps.editMode) {
      this.setState({
        formMode: editMode,
      });
    }
    if (machines !== prevProps.machines) {
      this.typeOfService['Služba']['Servis stroja'][
        'Typ stroja'
      ].selOptions = this.getMachinesTypes();
    }
  }

  getMachinesTypes() {
    const { machines } = this.props;
    const mcs = machines.map(m => m.label);
    const mcsi = machines.map(t => {
      return {
        label: t.label,
        value: t.label,
      };
    });
    this.setState({
      machineOptions: mcsi,
    });
    return mcs;
  }

  handleMultiSelect(selectedOptions, index) {
    const { handleOnChange1 } = this.props;
    if (handleOnChange1) {
      handleOnChange1(selectedOptions, index);
    }
  }

  render() {
    const {
      name,
      machines,
      handleOnChange,
      handleOnChange1,
      handleOnChange2,
      selectedVal,
      selectedVal1,
      selectedVal2,
      mainSelect,
      error,
      error1,
      error2,
    } = this.props;
    const { formMode, machineOptions } = this.state;

    return (
      <React.Fragment>
        <React.Fragment>
          {this.typeOfService && this.typeOfService.selOptions.length > 0
            ? this.typeOfService.selOptions.map((tos, index) => (
                <React.Fragment>
                  <React.Fragment>
                    <InputWrapperInline
                      style={{
                        width: '98.5%',
                        padding: 0,
                      }}
                    >
                      <Label>{tos}</Label>
                      <Select
                        disabled={formMode !== 'add'}
                        style={{
                          opacity: formMode !== 'add' ? 0.5 : 1,
                        }}
                        name={name}
                        // size="s"
                        error={error}
                        onChange={e => handleOnChange(e.target.value, index)}
                      >
                        {this.typeOfService[tos].selOptions.map(e => {
                          if (
                            selectedVal[index] &&
                            selectedVal[index].value &&
                            selectedVal[index].value === e
                          ) {
                            return (
                              <option key={uniqid()} selected value={e}>
                                {e}
                              </option>
                            );
                          }
                          return (
                            <option key={uniqid()} value={e}>
                              {e}
                            </option>
                          );
                        })}
                      </Select>
                    </InputWrapperInline>
                  </React.Fragment>
                  {selectedVal[index] &&
                  selectedVal[index].value &&
                  this.typeOfService[mainSelect][selectedVal[index].value] &&
                  this.typeOfService[mainSelect][selectedVal[index].value]
                    .selOptions.length > 0
                    ? this.typeOfService[mainSelect][
                        selectedVal[index].value
                      ].selOptions.map((tos1, indx) => (
                        <React.Fragment>
                          <InputWrapperInline
                            style={{
                              width: `${
                                this.typeOfService[mainSelect][
                                  selectedVal[index].value
                                ].selOptions.length === 1
                                  ? 92 / 2
                                  : 92 /
                                    this.typeOfService[mainSelect][
                                      selectedVal[index].value
                                    ].selOptions.length
                              }%`,
                              paddingLeft: indx === 0 ? 0 : rem(10),
                              paddingRight:
                                indx ===
                                this.typeOfService[mainSelect][
                                  selectedVal[index].value
                                ].selOptions.length -
                                  1
                                  ? 0
                                  : rem(10),
                            }}
                          >
                            <React.Fragment>
                              <Label>{tos1}</Label>
                              {tos1 === 'Typ stroja' ? (
                                <CustomMultiSelect
                                  disabled={formMode !== 'add'}
                                  style={{
                                    opacity: formMode !== 'add' ? 0.5 : 1,
                                  }}
                                  placeholder="Vyberte"
                                  options={machineOptions}
                                  value={
                                    selectedVal1 &&
                                    selectedVal1[1] &&
                                    selectedVal1[1].value.length > 0
                                      ? selectedVal1[1].value
                                      : []
                                  }
                                  onChange={selectedOptions => {
                                    this.handleMultiSelect(
                                      selectedOptions,
                                      indx,
                                    );
                                  }}
                                />
                              ) : (
                                <Select
                                  disabled={formMode !== 'add'}
                                  style={{
                                    opacity: formMode !== 'add' ? 0.5 : 1,
                                  }}
                                  name={name}
                                  // size="s"
                                  error={error1}
                                  onChange={e =>
                                    handleOnChange1(e.target.value, indx)
                                  }
                                >
                                  {this.typeOfService[mainSelect][
                                    selectedVal[index].value
                                  ][tos1].selOptions.map(e => {
                                    if (
                                      selectedVal1[indx] &&
                                      selectedVal1[indx].value &&
                                      selectedVal1[indx].value === e
                                    ) {
                                      return (
                                        <option
                                          key={uniqid()}
                                          selected
                                          value={e}
                                        >
                                          {e}
                                        </option>
                                      );
                                    }
                                    return (
                                      <option key={uniqid()} value={e}>
                                        {e}
                                      </option>
                                    );
                                  })}
                                </Select>
                              )}
                            </React.Fragment>
                          </InputWrapperInline>
                          {selectedVal1[indx] &&
                          selectedVal1[indx].value &&
                          this.typeOfService[mainSelect][
                            selectedVal[index].value
                          ][tos1] &&
                          this.typeOfService[mainSelect][
                            selectedVal[index].value
                          ][tos1][selectedVal1[indx].value] &&
                          this.typeOfService[mainSelect][
                            selectedVal[index].value
                          ][tos1][selectedVal1[indx].value].selOptions.length >
                            0 ? (
                            this.typeOfService[mainSelect][
                              selectedVal[index].value
                            ][tos1][selectedVal1[indx].value].selOptions.map(
                              (tos2, i) => (
                                <InputWrapperInline
                                  style={{
                                    width: `${
                                      this.typeOfService[mainSelect][
                                        selectedVal[index].value
                                      ][tos1][selectedVal1[indx].value]
                                        .selOptions.length === 1
                                        ? 98 / 2
                                        : 98 /
                                          this.typeOfService[mainSelect][
                                            selectedVal[index].value
                                          ][tos1][selectedVal1[indx].value]
                                            .selOptions.length
                                    }%`,
                                    paddingLeft: rem(20),
                                    paddingRight:
                                      i ===
                                      this.typeOfService[mainSelect][
                                        selectedVal[index].value
                                      ][tos1][selectedVal1[indx].value]
                                        .selOptions.length -
                                        1
                                        ? 0
                                        : rem(10),
                                  }}
                                >
                                  <React.Fragment>
                                    <Label>{tos2}</Label>
                                    <Select
                                      disabled={formMode !== 'add'}
                                      style={{
                                        opacity: formMode !== 'add' ? 0.5 : 1,
                                      }}
                                      name={name}
                                      // size="s"
                                      error={error2}
                                      onChange={e =>
                                        handleOnChange2(e.target.value, i)
                                      }
                                    >
                                      {this.typeOfService[mainSelect][
                                        selectedVal[index].value
                                      ][tos1][selectedVal1[indx].value][
                                        tos2
                                      ].selOptions.map(e => {
                                        if (
                                          selectedVal2[i] &&
                                          selectedVal2[i].value &&
                                          selectedVal2[i].value === e
                                        ) {
                                          return (
                                            <option
                                              key={uniqid()}
                                              selected
                                              value={e}
                                            >
                                              {e}
                                            </option>
                                          );
                                        }
                                        return (
                                          <option key={uniqid()} value={e}>
                                            {e}
                                          </option>
                                        );
                                      })}
                                    </Select>
                                  </React.Fragment>
                                </InputWrapperInline>
                              ),
                            )
                          ) : (
                            <React.Fragment>
                              {selectedVal[index].value === 'Marketing' ||
                              selectedVal[index].value === 'Reklamácia' ? (
                                <InputWrapperInline
                                  style={{
                                    width: `${98 / 2}%`,
                                    paddingLeft: rem(20),
                                    paddingRight: 0,
                                    opacity: 0.5,
                                  }}
                                >
                                  <Label>Ďalší výber</Label>
                                  <Select disabled name={name}>
                                    <option
                                      key={uniqid()}
                                      selected
                                      value="Vyberte"
                                    >
                                      Vyberte
                                    </option>
                                  </Select>
                                </InputWrapperInline>
                              ) : null}
                            </React.Fragment>
                          )}
                        </React.Fragment>
                      ))
                    : null}
                </React.Fragment>
              ))
            : null}
        </React.Fragment>
        {selectedVal1 &&
        selectedVal1[1] &&
        selectedVal1[1].value &&
        selectedVal1[1].value.length > 0 ? (
          <InputWrapperInline
            style={{
              width: '98.5%',
              padding: 0,
            }}
          >
            <Label>{__('Zvolené stroje pre servis: ')}</Label>
            <p />
            {machines.map((machine, index) => {
              if (selectedVal1[1].value[index] === machine.label) {
                return (
                  <Row>
                    <Label>{__('Názov: ')}</Label>
                    <Text style={{ width: rem(220) }}>
                      {machine.label}
                    </Text>{' '}
                    <Label>{__('Typ:')}</Label>{' '}
                    <Text>{machine.additionalData.machine_type}</Text>
                    <Label>{__('Ton. systém:')}</Label>
                    <Text>{machine.additionalData.toning_system}</Text>
                  </Row>
                );
              }
              return false;
            })}
            <p />
          </InputWrapperInline>
        ) : null}
      </React.Fragment>
    );
  }
}

SelectForm.propTypes = {
  machines: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  selectedVal: PropTypes.string.isRequired,
  selectedVal1: PropTypes.string.isRequired,
  selectedVal2: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  mainSelect: PropTypes.string.isRequired,
  handleOnChange: PropTypes.func.isRequired,
  handleOnChange1: PropTypes.func.isRequired,
  handleOnChange2: PropTypes.func.isRequired,
  editMode: PropTypes.bool.isRequired,
  error: PropTypes.bool.isRequired,
  error1: PropTypes.bool.isRequired,
  error2: PropTypes.bool.isRequired,
};

SelectForm.defaultProps = {};

const mapStateToProps = state => {
  return { userData: state };
};

export default connect(state => mapStateToProps(state))(SelectForm);



// WEBPACK FOOTER //
// ./src/Components/SelectForm/index.jsx